/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { EstimatedDuration } from '../enums/estimated-duration';
import { FocusArea } from '../enums/focus-area';
import { GeneralSkill } from '../enums/general-skill';
import { Industry } from '../enums/industry';
import { InterviewStatusType } from '../enums/interview-status-type';
import { LegalSkill } from '../enums/legal-skill';
import { LegalTechSkill } from '../enums/legal-tech-skill';
import { LevelOfExperience } from '../enums/level-of-experience';
import { OpportunityStage } from '../enums/opportunity-stage';
import { OpportunityStageCode } from '../enums/opportunity-stage-code';
import { PositionWorksite } from '../enums/position-worksite';
import { PracticeAreaEnum } from '../enums/practice-area-enum';
import { AccountEntity } from './account-entity';
import { ContactEntity } from './contact-entity';
import { DigitalIntakeDetailEntity } from './digital-intake-detail-entity';
import { OpportunityCollaboratorEntity } from './opportunity-collaborator-entity';
import { OpportunityLanguageEntity } from './opportunity-language-entity';
import { PositionEntity } from './position-entity';
import { UserEntity } from './user-entity';
export class OpportunityEntity extends Entity {
  account: AccountEntity | null = null;
  accountId: string | null = null;
  accountName: string | null = null;
  addressCity: string | null = null;
  addressCountryCode: string | null = null;
  addressState: string | null = null;
  addressStreet: string | null = null;
  addressZip: string | null = null;
  allowInterest: boolean | null = null;
  businessTeam: string | null = null;
  clientName: string | null = null;
  closedDate: string | null = null;
  collaborators: OpportunityCollaboratorEntity[] = [];
  confidential: boolean = false;
  contacts: ContactEntity[] = [];
  currency: string | null = null;
  deliveryManager: UserEntity | null = null;
  description: string | null = null;
  digitalIntakeDetails: DigitalIntakeDetailEntity | null = null;
  firstCandidateSelectedOrFurtherAt: string | null = null;
  firstCandidateSubmittedAt: string | null = null;
  id: string = '';
  isExcludedFromFeed: boolean | null = null;
  isQualificationComplete: boolean | null = null;
  jobName: string | null = null;
  languages: OpportunityLanguageEntity[] = [];
  locationCityStateCountry: string | null = null;
  madeAvailableToFeedAt: string | null = null;
  madeAvailableToFeedNotificationAt: string | null = null;
  nextStep: string | null = null;
  ownerUser: UserEntity | null = null;
  ownerUserId: string | null = null;
  position: PositionEntity | null = null;
  positions: PositionEntity[] = [];
  primaryFocusArea: FocusArea | null = null;
  primaryPracticeArea: PracticeAreaEnum | null = null;
  qualifiedAt: string | null = null;
  salesCloseDate: string | null = null;
  salesforceContactId: string | null = null;
  salesforceId: string | null = null;
  salesLead: UserEntity | null = null;
  salesLeadId: string | null = null;
  selfService: boolean = false;
  stage: OpportunityStage | null = null;
  stageCode: OpportunityStageCode | null = null;
  startDate: string | null = null;
  submissionId: string | null = null;
  submissionLastUpdatedAt: string | null = null;
  additionalDetailsForTalent?: string | null = null;
  billingUnitsPerWeek?: number | null = null;
  companyLocation?: Record<string, unknown> | null = null;
  contactId?: string | null = null;
  countryCode?: string | null = null;
  dsSuggestedId?: string | null = null;
  endDate?: string | null = null;
  estimatedDuration?: EstimatedDuration | null = null;
  generalSkills?: GeneralSkill[] | null = null;
  industry?: Industry | null = null;
  interviewNumber?: number | null = null;
  interviewStatus?: InterviewStatusType | null = null;
  isFulfillmentActive?: boolean | null = null;
  languageId?: string | null = null;
  legalSkills?: LegalSkill[] | null = null;
  legalTechSkills?: LegalTechSkill[] | null = null;
  levelOfExperience?: LevelOfExperience | null = null;
  opportunityId?: string | null = null;
  otherFocusAreas?: FocusArea[] | null = null;
  positionDescription?: string | null = null;
  salesforceCXLeadId?: string | null = null;
  sortDate?: string | null = null;
  worksite?: PositionWorksite | null = null;
  static override key = 'Opportunity';
  static override get schema() {
    return {
      account: AccountEntity,
      collaborators: [OpportunityCollaboratorEntity],
      contacts: [ContactEntity],
      deliveryManager: UserEntity,
      digitalIntakeDetails: DigitalIntakeDetailEntity,
      languages: [OpportunityLanguageEntity],
      ownerUser: UserEntity,
      position: PositionEntity,
      positions: [PositionEntity],
      salesLead: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Opportunity' in input
    ) {
      const { Opportunity: wrapped, ...rest } = input as {
        Opportunity: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}